import React from 'react';
import { User, LogOut, Settings } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const UserMenu = ({ onOpenAuth }) => {
  const { user, isAuthenticated, logout } = useAuth();
  const [isOpen, setIsOpen] = React.useState(false);

  if (!isAuthenticated) {
    return (
      <div className="flex items-center gap-2">
        <button
          onClick={() => onOpenAuth('login')}
          className="text-gray-300 hover:text-white px-4 py-2 transition-colors"
          data-testid="login-btn"
        >
          Sign In
        </button>
        <button
          onClick={() => onOpenAuth('register')}
          className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-colors"
          data-testid="signup-btn"
        >
          Sign Up
        </button>
      </div>
    );
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 rounded-full px-3 py-2 transition-colors"
        data-testid="user-menu-btn"
      >
        {user.avatar ? (
          <img src={user.avatar} alt={user.name} className="w-8 h-8 rounded-full" />
        ) : (
          <div className="w-8 h-8 rounded-full bg-red-600 flex items-center justify-center">
            <span className="text-white font-medium text-sm">
              {user.name?.charAt(0)?.toUpperCase() || 'U'}
            </span>
          </div>
        )}
        <span className="text-white text-sm hidden md:block">{user.name}</span>
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-48 bg-gray-900 border border-gray-800 rounded-lg shadow-xl z-50 overflow-hidden">
            <div className="px-4 py-3 border-b border-gray-800">
              <p className="text-white font-medium truncate">{user.name}</p>
              <p className="text-gray-500 text-sm truncate">{user.email}</p>
            </div>
            <div className="py-1">
              <button
                onClick={() => { setIsOpen(false); }}
                className="w-full flex items-center gap-3 px-4 py-2 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors"
              >
                <User size={18} />
                <span>Profile</span>
              </button>
              <button
                onClick={() => { setIsOpen(false); }}
                className="w-full flex items-center gap-3 px-4 py-2 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors"
              >
                <Settings size={18} />
                <span>Settings</span>
              </button>
              <button
                onClick={() => { logout(); setIsOpen(false); }}
                className="w-full flex items-center gap-3 px-4 py-2 text-red-400 hover:bg-gray-800 transition-colors"
                data-testid="logout-btn"
              >
                <LogOut size={18} />
                <span>Sign Out</span>
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UserMenu;
